// PKCE (Proof Key for Code Exchange) utilities
export class PKCE {
  // Генерирует случайную строку для code_verifier
  static generateCodeVerifier(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return this.base64URLEncode(array);
  }

  // Генерирует code_challenge из code_verifier
  static async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return this.base64URLEncode(new Uint8Array(digest));
  }

  // Base64URL encoding (без padding и с безопасными символами)
  private static base64URLEncode(buffer: Uint8Array): string {
    const base64 = btoa(String.fromCharCode.apply(null, Array.from(buffer)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  // Сохраняет PKCE данные в sessionStorage
  static savePKCEData(codeVerifier: string, state: string): void {
    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
    sessionStorage.setItem('pkce_state', state);
  }

  // Получает PKCE данные из sessionStorage
  static getPKCEData(): { codeVerifier: string | null; state: string | null } {
    return {
      codeVerifier: sessionStorage.getItem('pkce_code_verifier'),
      state: sessionStorage.getItem('pkce_state'),
    };
  }

  // Очищает PKCE данные из sessionStorage
  static clearPKCEData(): void {
    sessionStorage.removeItem('pkce_code_verifier');
    sessionStorage.removeItem('pkce_state');
  }

  // Генерирует случайный state для защиты от CSRF
  static generateState(): string {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return this.base64URLEncode(array);
  }
}
